import React, { useState, Fragment, useEffect } from 'react';
import {
  Row,
  Input,
  Label,
  CustomInput,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText, Tooltip
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ImageGallery from '../../../../propinfo/gallery/index';
import { Colxx } from '../../../../../../../components/common/CustomBootstrap';
import timeZoneOptions from '../../../../../../../data/timeZone';
import currencies from '../../../../../../../data/currencies';
import ContactsForm from './ContactsForm';
import DomainsForm from './DomainsForm';
import { AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import { gAPI_Internal_Property_By_Id } from '../../../../../../../constants/APIs';
import Select from 'react-select';
import country from '../../../../../../../data/country';
import { reactSelectOptionDiffrentPro } from '../../../../../../../helpers/Utils';
import timeZoneList from '../../../../../../../data/timeZoneList';
import currencyList from '../../../../../../../data/currencyList';
import Rating from '../../../../../../../components/common/Rating';
import moment from 'moment';

export function PropertyForm({
  visible,
  toggle,
  formLabel,
  submit,
  updatepropertyData,
  id, check,
  groupId,
}) {
  const [selectedCountry, setSelectedCountry] = useState({
    value: '',
    label: 'Please Select',
  });
  useEffect(() => {
    if (id !== undefined) {
      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_Internal_Property_By_Id}/${id}?group_id=${groupId}`,
      })
        .then((res) => {
        
          setStartDate(moment(res.data.activationDate).format('MMM DD, YYYY') === 'Jan 01, 0001' ? null
            : moment(res.data.activationDate));
          setpropertyData(res.data);
          // let currency = currencyList.filter(item => item.countryCode === res.data.country);
          let timeZones = timeZoneList.filter(
            (item) => item.IsoAlpha2 === res.data.country
          );
          const countryGroup = country.filter(
            (item) => item.code === res.data.country
          );
          let countrySelected = {
            value: countryGroup[0].code,
            label: countryGroup[0].name,
          };
          setSelectedCountry(countrySelected);
          // setpropertyData({
          //     ...propertyData,
          //     country: value.value,
          //     currency: currency[0].currencyCode
          // });

          
          setSelectZones(
            timeZones[0].TimeZones.map((zone) => {
              return <option value={zone}>{zone}</option>;
            })
          );
        })
        .catch((err) => console.log('err', err));
    }
  }, [id]);
  const [selectZones, setSelectZones] = useState();
  const [startDate, setStartDate] = useState(null);
  const [galleryVisible, setGalleryVisible] = useState(false);
  let [propertyData, setpropertyData] = useState(
    updatepropertyData || {
      groupId: groupId,
      type: 'hotel',
      name: '',
      currency: 'NZD',
      inventoryProvider: 'None',
      ratesProvider: 'None',
      bookingProvider: 'None',
      timeZone: 'None',
      ariUrl: '',
      bookingUrl: '',
      creator: 'Manually',
      isTemplate: false,
      displayOrder: 1,
      country: 'NZ',
      status: 'Active',
      websiteLink: '',
      rooms: 0,
      starRating: 0,
      images: 'https://via.placeholder.com/150/',
      bmbAccountManager: '',
      bmbVoucherProcessingFee: 0,
      customerSuccessManager: '',
      isBmb: false,
      isAiva: false,
      isVirtualFrontDesk: false,
      isRateBooking: false,
      activationDate: null,
      redeemAddress: '',
      averageDailyRate: 0,
      notSendApplicationFeeToStripe:false
    }
  );
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const handleChange = (e) => {
    setpropertyData({
      ...propertyData,
      [e.target.name]: e.target.value,
    });
  };
  const handleRateChange = (e) => {
    setpropertyData({
      ...propertyData,
      starRating: e.rating,
    });
  };
  const handleCheckedChange = (e) => {
    setpropertyData({
      ...propertyData,
      [e.target.name]: e.currentTarget.checked,
    });
  };
  const togglegallery = () => {
    // setImageIndex(index);
    setGalleryVisible(!galleryVisible);
  };


  const selectedImage = (image) => {

    setpropertyData({
      ...propertyData,
      images: image.src,
    });
  };
  
  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>
                  Select Image or Upload New Image
                </ModalHeader>
                <ModalBody>
                  <ImageGallery
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  const handleChangeSelect = (value, { name }) => {
    let currency = currencyList.filter(
      (item) => item.countryCode === value.value
    );
    let timeZones = timeZoneList.filter(
      (item) => item.IsoAlpha2 === value.value
    );
    setpropertyData({
      ...propertyData,
      country: value.value,
      currency: currency[0].currencyCode,
      timeZone: timeZones[0].TimeZones[0],
    });
    setSelectedCountry(value);
    setSelectZones(
      timeZones[0].TimeZones.map((zone) => {
        return <option value={zone}>{zone}</option>;
      })
    );
  };

  const handleSubmit = () => {
    if (startDate === null)
      propertyData.activationDate = "01/01/0001";
    else
      propertyData.activationDate = startDate.format('YYYY-MM-DD'
      );
    submit(propertyData);
  };

  const selectTimeZoneOptions = timeZoneOptions
    .sort(dynamicSort('label'))
    .map((item) => {
      return <option value={item.value}>{item.label}</option>;
    });

  const selectCurrencies = currencies.sort(dynamicSort('label')).map((item) => {
    return <option value={item.value}>{item.label}</option>;
  });

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      /* next line works with strings and numbers,
       * and you may want to customize it to your needs
       */
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }
  const handleChangeDate = (date) => {
    setpropertyData({ ...propertyData, activationDate: moment(date) });
  };
  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>{formLabel}</ModalHeader>
        <ModalBody>
          <Row className="">
            <Colxx xxs="12">
              {/* <pre>{JSON.stringify(propertyData, null, 2)}</pre> */}
              <Row>
                <Colxx sm={12} className="mb-3">
                  <Label>Property Name</Label>
                  <Input
                    type="text"
                    value={propertyData.name}
                    onChange={handleChange}
                    name="name"
                  />
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Property Type</Label>
                  <Input
                    type="select"
                    value={propertyData.type}
                    name="type"
                    onChange={handleChange}
                  >
                    <option value="Hotel">Hotel</option>
                    <option value="Motel">Motel</option>
                    <option value="Lodge">Lodge</option>
                    <option value="Resort">Resort</option>
                    <option value="CampGround">CampGround</option>
                    <option value="Bach">Bach</option>
                    <option value="Hostel">Hostel</option>
                    <option value="Pub">Pub</option>
                  </Input>
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Country</Label>
                  <Select
                    isMulti={false}
                    className="react-select"
                    classNamePrefix="react-select"
                    name="code"
                    placeholder="Select Country"
                    onChange={handleChangeSelect}
                    value={selectedCountry}
                    options={
                      country
                        ? reactSelectOptionDiffrentPro(
                          country,
                          true,
                          'code',
                          'name',
                          ''
                        )
                        : []
                    }
                  />
                </Colxx>
                {/* <Colxx sm={3} className="mb-3">
                                    <Label>Currency</Label>
                                    <Input
                                        required
                                        name="currency"
                                        type="select"
                                        onChange={handleChange}
                                        value={propertyData.currency}
                                    >
                                        {selectCurrencies}
                                    </Input>
                                </Colxx> */}
                {selectZones !== undefined && selectZones.length > 0 && (
                  <Colxx sm={4} className="mb-3">
                    <Label>Time Zone</Label>
                    <Input
                      type="select"
                      value={propertyData.timeZone}
                      name="timeZone"
                      onChange={handleChange}
                    >
                      {selectZones}
                    </Input>
                  </Colxx>
                )}

                <Colxx sm={4} className="mb-3">
                  <Label>Inventory Provider</Label>
                  <Input
                    type="select"
                    value={propertyData.inventoryProvider}
                    name="inventoryProvider"
                    onChange={handleChange}
                  >
                    <option value="None">None</option>
                    <option value="Rms">RMS</option>
                    <option value="Clarity">Clarity</option>
                    <option value="Bmb">Bmb</option>
                    <option value="External">External</option>
                    <option value="GuestTraction">Guest Traction</option>
                    <option value="TravelClick">Travel Click</option>
                  </Input>
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <FormGroup>
                    <Label> BMB Voucher Processing Fee
                    </Label>
                    <InputGroup>

                      <Input
                        type="number"
                        name="bmbVoucherProcessingFee"
                        id="bmbVoucherProcessingFee"
                        onChange={handleChange}
                        value={parseFloat(propertyData.bmbVoucherProcessingFee)}
                      />
                      <InputGroupAddon addonType='postpend'>
                        <InputGroupText>%</InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                    <Tooltip
                      isOpen={tooltipOpen}
                      placement="left"
                      target="bmbVoucherProcessingFee"
                      toggle={() => { setTooltipOpen(!tooltipOpen) }}>
                      Book Me Bob processing fee includes the credit card transaction fee that we directly pay out to the Credit Card processor.
                    </Tooltip>
                    {/* <Tooltip></Tooltip > */}
                  </FormGroup>
                </Colxx>

                <Colxx sm={4} className="mb-3">
                  <Label>Rates Provider</Label>
                  <Input
                    type="select"
                    value={propertyData.ratesProvider}
                    name="ratesProvider"
                    onChange={handleChange}
                  >
                    <option value="None">None</option>
                    <option value="Rms">RMS</option>
                    <option value="Clarity">Clarity</option>
                    <option value="Bmb">Bmb</option>
                    <option value="External">External</option>
                    <option value="GuestTraction">Guest Traction</option>
                    <option value="TravelClick">Travel Click</option>
                  </Input>
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Booking Provider</Label>
                  <Input
                    type="select"
                    value={propertyData.bookingProvider}
                    name="bookingProvider"
                    onChange={handleChange}
                  >
                    <option value="None">None</option>
                    <option value="Rms">RMS</option>
                    <option value="Clarity">Clarity</option>
                    <option value="Bmb">Bmb</option>
                    <option value="External">External</option>
                    <option value="GuestTraction">Guest Traction</option>
                    <option value="TravelClick">Travel Click</option>
                  </Input>
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Average Daily Rate</Label>
                  <Input
                    type="number"
                    min={0}
                    value={propertyData.averageDailyRate}
                    name="averageDailyRate"
                    onChange={handleChange}
                  ></Input>
                </Colxx>
                <Colxx sm={12} className="mb-3">
                  <Label>ARI URL</Label>
                  <Input
                    type="text"
                    value={propertyData.ariUrl}
                    onChange={handleChange}
                    name="ariUrl"
                  />
                </Colxx>
                <Colxx sm={12} className="mb-3">
                  <Label>Booking Page URL</Label>
                  <Input
                    type="text"
                    value={propertyData.bookingUrl}
                    onChange={handleChange}
                    name="bookingUrl"
                  />
                </Colxx>

                <Colxx sm={2} className="mb-3">
                  <Label>Display Order</Label>
                  <Input
                    type="number"
                    name="displayOrder"
                    min={1}
                    value={propertyData.displayOrder}
                    onChange={handleChange}
                  />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <Label>Status</Label>
                  <Input
                    type="select"
                    value={propertyData.status}
                    name="status"
                    onChange={handleChange}
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                    <option value="Archived">Archived</option>
                  </Input>
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <FormGroup>
                    <Label>
                      <Input
                        type="checkbox"
                        name="isTemplate"
                        id="isTemplate"
                        onChange={handleCheckedChange}
                        checked={propertyData.isTemplate}
                      />
                      Is Template
                    </Label>
                  </FormGroup>
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Rooms</Label>
                  <Input
                    type="number"
                    value={propertyData.rooms}
                    onChange={handleChange}
                    name="rooms"
                  />
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>Website Link</Label>
                  <Input
                    type="text"
                    value={propertyData.websiteLink}
                    onChange={handleChange}
                    name="websiteLink"
                  />
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>Star Rating</Label>
                  <Rating
                    total={7}
                    rating={propertyData.starRating}
                    onRate={handleRateChange}
                  />
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>BMB Account Manager</Label>
                  <Input
                    type="text"
                    value={propertyData.bmbAccountManager}
                    onChange={handleChange}
                    name="bmbAccountManager"
                  />
                </Colxx>

                <Colxx sm={6} className="mb-3">
                  <Label>Customer Success Manager</Label>
                  <Input
                    type="text"
                    value={propertyData.customerSuccessManager}
                    onChange={handleChange}
                    name="customerSuccessManager"
                  />
                </Colxx>
              </Row>
            </Colxx>

            <Colxx sm={6} className="mb-2">
              <Label>Activation Date</Label>
              {/* <DatePicker
                selected={moment(propertyData.activationDate).format('MMM DD, YYYY') === 'Jan 01, 0001' ? moment() : moment(propertyData.activationDate)}
                onChange={handleChangeDate}
                placeholderText="Activation Date"
                dateFormat="DD/MM/YYYY"
              /> */}
              <DatePicker
                selected={startDate}
                onChange={date => setStartDate(date)}
                placeholderText="Activation Date"
                dateFormat="DD/MM/YYYY"
              />
            </Colxx>
            <Colxx sm={6} className="mb-3">
              <Label>Redeem At Address</Label>
              <Input
                type="textarea"
                value={propertyData.redeemAddress}
                name="redeemAddress"
                onChange={handleChange}
              >
              </Input>
            </Colxx>
            <Colxx sm={6} className="mb-3">
              <Label>Don`t Send Application Fee To Stripe</Label>
              <CustomInput
                type="checkbox"
                id="notSendApplicationFeeToStripe"
                checked={propertyData.notSendApplicationFeeToStripe}
                name="notSendApplicationFeeToStripe"
                onChange={(e) => setpropertyData({
                  ...propertyData,
                  [e.target.name]: e.target.checked,
                })}
              />
            </Colxx>
            <Colxx sm={12} className="mb-3">
              <div style={{ display: "flex", justifyContent: "space-between", marginTop: "35px" }}>
                <FormGroup className="ml-4">
                  <Label>
                    <Input
                      type="checkbox"
                      name="isBmb"
                      id="isBmb"
                      onChange={handleCheckedChange}
                      checked={propertyData.isBmb}
                    />
                    Book Me Bob
                  </Label>
                </FormGroup>
                <FormGroup className="ml-2">
                  <Label>
                    <Input
                      type="checkbox"
                      name="isAiva"
                      id="isAiva"
                      onChange={handleCheckedChange}
                      checked={propertyData.isAiva}
                    />
                    aiva
                  </Label>
                </FormGroup>
                <FormGroup className="ml-2">
                  <Label>
                    <Input
                      type="checkbox"
                      name="isVirtualFrontDesk"
                      id="isVirtualFrontDesk"
                      onChange={handleCheckedChange}
                      checked={propertyData.isVirtualFrontDesk}
                    />
                    Virtual Front Desk
                  </Label>
                </FormGroup>
                <FormGroup className="ml-2">
                  <Label>
                    <Input
                      type="checkbox"
                      name="isRateBooking"
                      id="isRateBooking"
                      onChange={handleCheckedChange}
                      checked={propertyData.isRateBooking}
                    />
                    Rates & Availability
                  </Label>
                </FormGroup>
              </div>
            </Colxx>

            <Fragment><Colxx sm={12}>
              <h4>Logo</h4>
            </Colxx>
              <Colxx sm={12}>

                <Row>
                  <Colxx sm={2} className="md-3">
                    <img
                      style={{
                        width: '100%',
                        height: '90%',
                      }}
                      alt="room image"
                      src={
                        propertyData.images || 'https://via.placeholder.com/150/'
                      }
                    />
                  </Colxx>
                  <Colxx sm={1} className="mb-3">
                    <Label>Browse</Label>
                    <div
                      className="iconsminds-photo"
                      onClick={(event) => togglegallery()}
                      style={{
                        cursor: 'pointer',
                        fontSize: '28px',
                        color: '#73236b',
                      }}
                    ></div>
                  </Colxx>
                </Row>
              </Colxx>

            </Fragment>

          </Row>
          {ImageGalleryButton()}
          {
            propertyData.contacts && (
              <ContactsForm images={propertyData.contacts} id={id} />
            )
          }
          {
            propertyData.domains && (
              <DomainsForm domains={propertyData.domains} id={id} />
            )
          }
        </ModalBody >
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            Save
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal >

    </Fragment >
  );
}
